export default "__VITE_ASSET__4kPht4s1__"